import { AuthContext } from '@core/shared';
import { useSiteSettingsContext } from '@core/shared/src/components/SiteSettingsProvider';
import { WebinarContentSummary } from '@core/swagger-client';
import { Menu, MenuItem, Options } from '@core/ui';
import { Link } from '@online-webinar/ui-frontend';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItemOption } from '../../atoms';

export const UpNextWebinarActions = ({ webinar }: { webinar: WebinarContentSummary }) => {
    const { t } = useTranslation();
    const canManageEmailLists = useContext(AuthContext).canManageEmailLists;
    const isVerified = useContext(AuthContext).isVerified;
    const isWhitelabel = useSiteSettingsContext().isWhitelabel;

    return (
        <div className="bg-accent-light flex flex-wrap gap-4">
            <Link
                to="/$webinarId/share"
                params={{ webinarId: webinar.webinarId }}
                state={{ backTo: 'overview' }}
                variant="secondary"
                classNames="grow xs:grow-0"
                disabled={!webinar.isPublished}
            >
                {t('WebinarUpNext.Button.Share')}
            </Link>
            <Link to="/test-suite" variant="secondary-outline" classNames="grow max-xs:order-3 xs:grow-0 xs:me-auto">
                {t('WebinarUpNext.Button.Test')}
            </Link>
            <Menu
                position="bottom"
                classNames="w-full max-xs:order-2 btn btn--outline-primary"
                menuComponent={
                    <span className="flex items-center gap-4">
                        {t('Menu.Dropdown.Options')}
                        <Options classNames="size-6 2xl:size-7 -me-2 fill-current" />
                    </span>
                }
            >
                <MenuItem>
                    <MenuItemOption to="/$webinarId/content" params={{ webinarId: webinar.webinarId }} state={{ backTo: 'overview' }}>
                        {t('OptionMenu.Content')}
                    </MenuItemOption>
                </MenuItem>
                <MenuItem>
                    <MenuItemOption to="/$webinarId/security" params={{ webinarId: webinar.webinarId }} state={{ backTo: 'overview' }}>
                        {t('OptionMenu.Security')}
                    </MenuItemOption>
                </MenuItem>
                <MenuItem>
                    <MenuItemOption to="/$webinarId/share" params={{ webinarId: webinar.webinarId }} state={{ backTo: 'overview' }}>
                        {t('OptionMenu.Share')}
                    </MenuItemOption>
                </MenuItem>
                {!!isWhitelabel && canManageEmailLists && (
                    <MenuItem>
                        <MenuItemOption to="/$webinarId/marketing" params={{ webinarId: webinar.webinarId }} state={{ backTo: 'overview' }}>
                            {t('OptionMenu.Marketing')}
                        </MenuItemOption>
                    </MenuItem>
                )}
                <MenuItem>
                    <MenuItemOption to="/$webinarId/insights" params={{ webinarId: webinar.webinarId }} state={{ backTo: 'overview' }}>
                        {t('OptionMenu.Insights')}
                    </MenuItemOption>
                </MenuItem>
                {webinar.numberOfSlides !== 0 && (
                    <MenuItem>
                        <MenuItemOption to="/$webinarId/slide-controller" params={{ webinarId: webinar.webinarId }} state={{ backTo: 'overview' }}>
                            {t('OptionMenu.SlideController')}
                        </MenuItemOption>
                    </MenuItem>
                )}
                <MenuItem>
                    <MenuItemOption to="/test-suite" params={{ webinarId: webinar.webinarId }}>
                        {t('OptionMenu.Test')}
                    </MenuItemOption>
                </MenuItem>
            </Menu>
            <Link
                to="/$webinarId/broadcast"
                params={{ webinarId: webinar.webinarId }}
                variant="success"
                classNames="w-full xs:w-auto max-xs:order-4"
                disabled={!webinar.isPublished || !isVerified}
            >
                {t('WebinarUpNext.Button.StartBroadcast')}
            </Link>
        </div>
    );
};
